import { createContext } from "react";

import { JsonApiClient } from "../utils/createJsonApiClient/createJsonApiClient";

export const ApiContext = createContext<{ jsonApi: JsonApiClient }>({
  get jsonApi(): never {
    throw new Error("Missing jsonApi");
  },
});
